import React from 'react';
import { useMenuIconAnimation } from './useMenuIconAnimation';
import './TasksAnimatedIcon.css';

const ACTIVE_COLOR = '#3262FF';
const INACTIVE_COLOR = '#282932';

function TasksAnimatedIcon({ color, isActive = false, size = 24 }) {
  const strokeColor = color || (isActive ? ACTIVE_COLOR : INACTIVE_COLOR);
  const { playing, handleClick } = useMenuIconAnimation(isActive, 800);

  return (
    <span
      className={[
        'tasks-animated-icon',
        playing ? 'tasks-animated-icon--playing' : '',
        isActive && !playing ? 'tasks-animated-icon--active' : '',
      ].filter(Boolean).join(' ')}
      style={{ '--task-icon-stroke': strokeColor, width: size, height: size }}
      onClick={handleClick}
      role="presentation"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect className="task-icon-stroke task-icon-body" x="4.5" y="4" width="15" height="16.5" rx="2" />
        <path
          className="task-icon-clip"
          d="M9.5 4 A2.5 2.5 0 0 1 14.5 4 V5 H9.5 Z"
        />
        <path className="task-icon-stroke task-icon-line1" d="M7.5 10.5 H16.5" />
        <path className="task-icon-stroke task-icon-line2" d="M7.5 14.5 H13.5" />
      </svg>
    </span>
  );
}

export default TasksAnimatedIcon;
